import UpdateProductionPlant from './UpdateProductionPlant';

export default UpdateProductionPlant;
